import { ArtworkImage } from './ArtworkImage';
export const BastToken = () => {
    return (
        <div className='investigator-bast-token'>
            <ArtworkImage alt='Bast token' src='/Guardians/BastToken.jpg' />
        </div>
    )
}
